/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

export type ErrorGroupEventsSource =
  (typeof ErrorGroupEventsSource)[keyof typeof ErrorGroupEventsSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ErrorGroupEventsSource = {
  backend: "backend",
  frontend: "frontend",
} as const;
